<script lang="ts">
    import Button, { Label } from '@smui/button';
    import Select, { Option } from '@smui/select';
    import Icon from '@smui/select/icon';
    import { _ } from 'svelte-i18n';
    import Area from '../../../../shared/models/Area/Area';
    import AziendaEnte from '../../../../shared/models/AziendaEnte/AziendaEnte';
    import Utente, { ImpersonateRequest } from '../../../../shared/models/Utente/Utente';
    import FieldLoading from './../../../..//shared/components/common/Loading/FieldLoading.svelte';
    import { impersonate, userSession } from './../../../../shared/stores';
    
	let selectedArea, selectedAziendaEnte, selectedRole;

    let [data, loading, error] = Utente.get($userSession?.userId);
	let [dataRoles, loadingRoles, errorRoles] = Utente.getRolesList();
	let [dataAree, loadingAree, errorAree] = Area.getList({ elementiPerPagina: 1000 });
	let [dataAziendeEnti, loadingAziendeEnti, errorAziendeEnti] = AziendaEnte.getList({ areaId: $data.area.id, elementiPerPagina: 1000 });

	$: selectedArea = $data.area;
	$: selectedAziendaEnte = $data.aziendaEnte;
	$: selectedRole = $data.role;

	$: if (!$data.role || $data.role == '' || $data.role == 'Sys Admin') {
		$data.area = new Area();
		$data.aziendaEnte = new AziendaEnte();
	}

	data.subscribe((value) => {
		if (value.area && value.area != selectedArea) {
			let [dataAziendeEnti, loadingAziendeEnti, errorAziendeEnti] = AziendaEnte.getList({ areaId: value.area.id, elementiPerPagina: 1000 });
		}
	});

    function onImpersonation() {
        let impersonateRequest: ImpersonateRequest = {
            role: selectedRole,
            area: selectedArea?.id,
            aziendaEnte: selectedAziendaEnte?.id
        }
        
        let [dataImpersonificazione, loadingImpersonificazione, errorImpersonificazione] = Utente.impersonate(impersonateRequest);
        dataImpersonificazione.subscribe((value) => {
            if (value) {
                impersonate(value);
            }
        });
    }

    function onStopImpersonation() {
        let [dataStopImpersonificazione, loadingStopImpersonificazione, errorStopImpersonificazione] = Utente.stopImpersonation();
        dataStopImpersonificazione.subscribe((value) => {
            if (value) {
                impersonate(value);
            }
        });
    }
</script>

{#if $loadingRoles}
    <FieldLoading />
{:else if $dataRoles}
    <Select
        key="{(role) => `${role || ''}`}"
        label="{$_('page.user.detail.role')}"
        bind:value="{selectedRole}"
        disabled={$userSession?.isImpersonating}
    >
        <Icon class="material-icons" slot="leadingIcon">manage_accounts</Icon>
        {#if $dataRoles}
            <Option value="{''}" on:click="{() => ($data.role = '')}" />
            {#each $dataRoles as role}
                {#if role}
                    <Option
                        value="{role}"
                        on:click="{() => {
                            $data.role = role;
                        }}">{role}</Option
                    >
                {/if}
            {/each}
        {/if}
    </Select>
{/if}
{#if $data?.role && $data.role !== '' && $data.role !== 'Sys Admin'}
    {#if $loadingAree}
        <FieldLoading/>
    {:else}
        <Select
            key="{(area) => `${(area && area.id) || ''}`}"
            label="{$_('page.user.detail.area')}"
            bind:value="{selectedArea}"
            disabled={$userSession?.isImpersonating}
        >
            {#if $dataAree.response}
                {#each $dataAree.response as area (area.id)}
                    {#if area.nomeComune}
                        <Option
                            value="{area}"
                            on:click="{() => {
                                $data.area = area;
                                [dataAziendeEnti, loadingAziendeEnti, errorAziendeEnti] = AziendaEnte.getList({ areaId: area.id, elementiPerPagina: 1000 });
                            }}">{area.nomeComune}</Option
                        >
                    {/if}
                {/each}
            {/if}
        </Select>
    {/if}
    {#if $loadingAziendeEnti}
        <FieldLoading />
    {:else if $data?.role && $data?.role !== '' && $data.role !== 'Area Manager' && selectedArea?.id}
        <Select
            key="{(aziendaEnte) => `${(aziendaEnte && aziendaEnte.id) || ''}`}"
            label="{$_('page.user.detail.company/entity')}"
            bind:value="{selectedAziendaEnte}"
            disabled={$userSession?.isImpersonating}
        >
            {#if $dataAziendeEnti && $dataAziendeEnti.response}
                {#each $dataAziendeEnti.response as aziendaEnte (aziendaEnte.id)}
                    {#if aziendaEnte.nomeAziendaEnte}
                        <Option value="{aziendaEnte}" on:click="{() => ($data.aziendaEnte = aziendaEnte)}">{aziendaEnte.nomeAziendaEnte}</Option>
                    {/if}
                {/each}
            {/if}
        </Select>
    {/if}
    {#if $userSession?.isImpersonating}
        <Button variant="raised" on:click={onStopImpersonation}>
            <Label>{$_('page.user.stopImpersonation')}</Label>
        </Button>
    {:else}
        <Button disabled={($data?.role === 'Area Manager' && (!selectedArea || selectedArea?.id <= 0)) || ($data?.role === 'Company Manager' && (!selectedAziendaEnte || selectedAziendaEnte.id <= 0))} variant="raised" on:click={onImpersonation}>
            <Label>{$_('page.user.impersonate')}</Label>
        </Button>
    {/if}
{/if}